import React from "react";

import {
  FamilyDomainTask1,
  FamilyDomainTask2,
  FamilyDomainTask3,
  FamilyDomainTask4,
  FamilyDomainTask5,
  FamilyDomainTask6,
  FamilyDomainTask7,
  FamilyDomainTask8,
  FamilyDomainTask9,
  FamilyDomainTask10,
  FamilyDomainTaskPlaceholder
} from "./FamilyDomainTasks";

interface FamilyDomainTaskFactoryProps {
  slideKey: string;
  setHeader: (header: string) => void;
  questionCompleter: any
}

const FamilyDomainTaskFactory: React.FC<FamilyDomainTaskFactoryProps> = (
  props
) => {
  const { slideKey, setHeader, questionCompleter } = props;

  const getCurrentSlide = () => {
    switch (slideKey) {
      case "FamilyDomainTask1":
        return FamilyDomainTask1;
      case "FamilyDomainTask2":
        return FamilyDomainTask2;
      case "FamilyDomainTask3":
        return FamilyDomainTask3;
      case "FamilyDomainTask4":
        return FamilyDomainTask4;
      case "FamilyDomainTask5":
        return FamilyDomainTask5;
      case "FamilyDomainTask6":
        return FamilyDomainTask6;
      case "FamilyDomainTask7":
        return FamilyDomainTask7;
      case "FamilyDomainTask8":
        return FamilyDomainTask8;
      case "FamilyDomainTask9":
        return FamilyDomainTask9;
      case "FamilyDomainTask10":
        return FamilyDomainTask10;
      default:
        return FamilyDomainTaskPlaceholder;
    }
  };

  const currentSlide = getCurrentSlide()!(questionCompleter);

  setHeader(currentSlide.header);

  return <>{currentSlide.content}</>;
};

export default FamilyDomainTaskFactory;
